import { StoryRun } from './types';

/**
 * Splits story text on `**` into plain and bold runs. Clients render the runs as text nodes,
 * so release copy cannot inject HTML. An unbalanced `**` stays as literal text.
 */
export function parseStoryMarkup(text: string): StoryRun[] {
  const parts = text.split('**');
  if (parts.length % 2 === 0) {
    return text ? [{ text, bold: false }] : [];
  }
  return parts.map((part, index) => ({ text: part, bold: index % 2 === 1 })).filter((run) => run.text !== '');
}

/** A story run with a React key: the position of the run in the plain text, which never repeats. */
export interface KeyedStoryRun extends StoryRun {
  key: string;
}

/** `parseStoryMarkup` with a stable key on each run, so a client needs no array index as a key. */
export function keyedStoryRuns(text: string): KeyedStoryRun[] {
  let offset = 0;
  return parseStoryMarkup(text).map((run) => {
    const key = String(offset);
    offset += run.text.length;
    return { ...run, key };
  });
}

/** Story text without the markup. Use it for plain-text mail and for places that cannot style. */
export function stripStoryMarkup(text: string): string {
  return parseStoryMarkup(text)
    .map((run) => run.text)
    .join('');
}
